module.exports = __webpack_public_path__ + "static/media/xcode.8b982e13.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/xcode.png
// module id = 216
// module chunks = 0